__turbopack_context__.v({
  "dot": "oJwlTW_dot",
  "dots": "oJwlTW_dots",
  "dotsTextLine": "oJwlTW_dotsTextLine",
  "typingBounce": "oJwlTW_typingBounce",
});
